// extracted by mini-css-extract-plugin
var _1 = "Fyuq4tcsGZyhWJ2kCTYI";
var _2 = "XhCqo6BTmaB5TFWxezka";
var _3 = "ojF4HRXXunwGUeHvrxDH";
var _4 = "b0yP2Q1R1HPmtEf8HHsv";
var _5 = "jBOoXrgNQ36jJYDyQsRg";
var _6 = "HeOHM2KE5VnZvCKmQuTB";
export { _1 as "colDeactivation", _2 as "colLastUpdated", _3 as "colModelTypes", _4 as "colName", _5 as "colOrgType", _6 as "colStatus" }
